<template>
    <div name="search-bar" class="search-bar">
        <img style="width: 94px;" src="../../../assets/concierge_logo.png" />
        <span class="title">가까운 <span style="font-weight: 600;">인슐린·바크시미 약국</span>을 한눈에!</span>
        <span class="description">한국1형당뇨병환우회 X 솔닥컨지어지가 함께 제작합니다.</span>
        <div style="position: relative; width: 100%;">
            <img src="../../../assets/search.png" class="search-icn" @click="onSearch" />
            <input class="input-big" 
                style="padding-left: 37px; margin-top: 20px;"
                v-focus-background
                @input="onInput" 
                v-model="keyword"
                ref="searchInput"
                placeholder="약국명, 주소, 인슐린 검색"
            />
        </div>

        <div class="row" style="margin-top: 20px;">
            <button class="button" @click="modeChange">
                <img src="../../../assets/map.png" style="margin-right: 4px;"/>
                지도보기</button>
            <!-- <button class="button" @click="getLocation()">
                <img src="../../../assets/location.png"/>
                <span v-if="location !== ''" style="margin-left: 8px;">{{ location }}</span></button> -->
            <location-select-box 
                :options="locationData"
                :selectedCityIndex="selectedCityIndex"
                :selectedSubcityIndex="selectedSubcityIndex"
                :placeHolder="'시/도'"
                :title="'시/도 선택해 주세요'"
                @select="selectLocation"
            />
            <medicine-filter style="margin-left: 8px;" />
        </div>
        <medicine-filter-notice />
    </div>
</template>

<script>
import focusBackground from '@/components/directives/focusBackground';
import { debounce } from 'lodash';
import LocationSelectBox from '@/components/atoms/LocationSelectBox.vue';
import MedicineFilter from '@/components/molecules/maps/MedicineFilter';
import MedicineFilterNotice from '@/components/molecules/maps/MedicineFilterNotice';
import Location from '@/utilities/location'
import {mapState} from 'vuex';
import Constant from '@/constant';
export default {
    name: 'searchBar',
    directives: {
        focusBackground
    },
    components: {
        LocationSelectBox,
        MedicineFilter,
        MedicineFilterNotice
    },
    data: function()
    {
        return {
            keyword: this.preKeyword,
            location: '논현동',
            longitude: 127.0276642,  //솔닥 주소
            latitude: 37.5191166,
            // 카카오 region_1depth_name -> locationData cityName (순서가 달라서 이름으로 찾는다)
            regionToCityName: {
                '서울': '서울',
                '부산': '부산',
                '대구': '대구',
                '인천': '인천',
                '광주': '광주',
                '대전': '대전',
                '울산': '울산',
                '세종특별자치시': '세종',
                '경기': '경기',
                '강원특별자치도': '강원도',
                '충북': '충청북도',
                '충남': '충청남도',
                '전북특별자치도': '전라북도',
                '전남': '전라남도',
                '경북': '경상북도',
                '경남': '경상남도',
                '제주특별자치도': '제주도'
            },
            locationData: Location.data,
            selectedCityIndex: -1,
            selectedSubcityIndex: 0
        }
    },
    computed: mapState(['pharmacies']),
    props: ['preKeyword', 'isMapSearch', 'preLatitude', 'preLongitude', 'zoomLevel'],
    mounted: async function()
    {
        if(this.isMapSearch)
        {
       
            // this.checkLocation();
            // await this.getAddressFromCoords(this.preLatitude, this.preLongitude);
            // this.latitude = this.preLatitude;
            // this.longitude = this.preLongitude;
            // this.$emit('onSearch', this.keyword, this.latitude, this.longitude);
        }
        else
        {
            if(this.pharmacies.length > 0)
            {
                
            }
            else
            {
                this.getLocation();
            }
       
        }

    },
    methods: {
        selectLocation: function(cityIndex, subcityIndex)
        {
            this.selectedCityIndex = cityIndex;
            this.selectedSubcityIndex = subcityIndex
    
            // this.location = this.locationData[index].name;
            // this.longitude = this.locationData[index].longitude;
            // this.latitude = this.locationData[index].latitude;
            this.$emit('onSearchByLocation', this.keyword, this.locationData[cityIndex].cityName, this.locationData[cityIndex].subCities[subcityIndex].name);
            // 지역 으로 변경 
            // 지역 선택
            // location 변경 
            // 재검색
        },
        checkLocation: function()
        {
            if (navigator.geolocation) {
                const options = {
                    enableHighAccuracy: true, // (선택) 좀 더 정확한 위치 요청
                    timeout: 5000,            // 5초 이상 걸리면 실패로 간주
                    maximumAge: 0             // 캐시된 위치 무시
                };

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const lat = position.coords.latitude;
                        const lng = position.coords.longitude;
                        this.longitude = lng;
                        this.latitude = lat;
                        // console.log("현재 위치:", lat, lng);
                        this.getAddressFromCoords(lat, lng);
                    },
                    (error) => {
                        // error.code 값에 따라 메시지 다르게 처리 가능

                        let msg = "위치 정보를 가져올 수 없습니다.";
                        if (error.code === error.TIMEOUT) {
                            msg = "요청이 너무 오래 걸려 위치 정보를 가져오지 못했습니다.";
                        } else if (error.code === error.PERMISSION_DENIED) {
                            msg = "위치 접근이 차단되었습니다.";
                        } else if (error.code === error.POSITION_UNAVAILABLE) {
                            msg = "위치 정보를 사용할 수 없습니다.";
                        }
                        console.error(msg, error);
                    },
                    options
                );
            } else {
                console.error("이 브라우저에서는 위치 정보를 사용할 수 없습니다.");
            }
        },
        getLocation: function()
        {
            if (navigator.geolocation) {
                const options = {
                    enableHighAccuracy: true, // (선택) 좀 더 정확한 위치 요청
                    timeout: 5000,            // 5초 이상 걸리면 실패로 간주
                    maximumAge: 0             // 캐시된 위치 무시
                };
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const lat = position.coords.latitude;
                        const lng = position.coords.longitude;
                        this.longitude = lng;
                        this.latitude = lat;
                        // 지역 검색 시 가까운 순 정렬에 쓰인다 (주소 변환 후 검색하므로 먼저 저장)
                        this.$store.commit(Constant.SET_PHARMACY_USER_LOCATION, {
                            latitude: lat,
                            longitude: lng
                        });

                        // console.log("현재 위치:", lat, lng);
                        this.getAddressFromCoords(lat, lng);
                        // 현재 위치로 검색 
                        // this.$emit('onSearch', this.keyword, this.latitude, this.longitude);
                    },
                    (error) => {
                            // console.log("" + JSON.stringify(error.code))
                        // error.code 값에 따라 메시지 다르게 처리 가능
                        let msg = "위치 정보를 가져올 수 없습니다.";
                        if (error.code === error.TIMEOUT) {
                            msg = "요청이 너무 오래 걸려 위치 정보를 가져오지 못했습니다.";
                        } else if (error.code === error.PERMISSION_DENIED) {
                            msg = "위치 접근이 차단되었습니다.";
                        } else if (error.code === error.POSITION_UNAVAILABLE) {
                            msg = "위치 정보를 사용할 수 없습니다.";
                        }
                        alert(msg)
                        this.selectedCityIndex = 0;
                        this.$emit('onSearchByLocation', this.keyword, this.locationData[this.selectedCityIndex].cityName, this.locationData[this.selectedCityIndex].subCities[this.selectedSubcityIndex].name);

                        // 현재 위치로 검색 
                        // this.$emit('onSearch', this.keyword, this.latitude, this.longitude);
                    },
                    options
                );
            } else {
                console.error("이 브라우저에서는 위치 정보를 사용할 수 없습니다.");
                alert("이 브라우저에서는 위치 정보를 사용할 수 없습니다.")
                this.selectedCityIndex = 0;
                this.$emit('onSearchByLocation', this.keyword, this.locationData[this.selectedCityIndex].cityName, this.locationData[this.selectedCityIndex].subCities[this.selectedSubcityIndex].name);
            }
        },
        getAddressFromCoords: async function (lat, lng) {
            const kakaoApiKey = "4eca03eb97fb84989f2bc1d6a1419b95"; // 카카오 REST API 키
            const url = `https://dapi.kakao.com/v2/local/geo/coord2address.json?x=${lng}&y=${lat}`;

            fetch(url, {
                headers: { "Authorization": `KakaoAK ${kakaoApiKey}` }
            })
            .then(response => response.json())
            .then(data => {
                if (data.documents.length > 0) {
                    const address = data.documents[0].address;
                  
                    console.log("시/도:", address.region_1depth_name);

                    const cityName = this.regionToCityName[address.region_1depth_name];
                    const cityIndex = this.locationData.findIndex((city) => city.cityName === cityName);
                    if(cityIndex > -1)
                    {
                        this.selectedCityIndex = cityIndex;
                        this.$emit('onSearchByLocation', this.keyword, this.locationData[this.selectedCityIndex].cityName, this.locationData[this.selectedCityIndex].subCities[this.selectedSubcityIndex].name);
                    }

                    console.log("구:", address.region_2depth_name);  // 📌 행정구 (區)

                    console.log("동:", address.region_3depth_name);
                    this.location = address.region_3depth_name;
                } else {
                    // console.log("구 정보를 찾을 수 없습니다.");
                }
            })
            .catch(error => console.error("카카오 API 오류:", error));
        },
        onSearch: function()
        {   
            this.$emit('onSearch', this.keyword, this.latitude, this.longitude);
        },
        onInput: debounce(function (event) {
            this.keyword = event.target.value

            if(this.selectedCityIndex !== -1 && this.selectedSubcityIndex !== -1)
            {
                this.$emit('onSearchByLocation', this.keyword, this.locationData[this.selectedCityIndex].cityName, this.locationData[this.selectedCityIndex].subCities[this.selectedSubcityIndex].name);
            }
            else
            {
                this.$emit('onSearch', event.target.value, this.latitude, this.longitude);
            }
        }, 500),
        modeChange: function()
        {
            if(this.pharmacies.length > 0)
            {
                this.$emit('viewMaps', this.pharmacies[0])
            }
            else
            {
                this.$emit('modeChange', this.keyword, this.zoomLevel)
            }
            
        }
    }

}
</script>

<style scoped>
    .search-bar {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 16px;
        box-sizing: border-box;
        background: #FFF;
    }
    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
        margin-top: 16px;
    }

    .description {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 142.857% */
        margin-top: 8px;
    }
    .button {
        position: fixed;
        display: flex;
        height: 44px;
        padding: 0 16px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 17px; /* 94.444% */
        border-radius: 100px;
        border-radius: 100px;
        border: 1px solid #184FA1;
        background: var(--Gray-00, #FFF);
        box-shadow: 0px 2px 10px 0px rgba(0, 33, 56, 0.16);
        cursor: pointer;
        margin-right: 8px;
        bottom: 24px;
        left: 50%;
        transform: translate(-50%, 0);
    }
    .row {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        scrollbar-width: none;
    }
    .row::-webkit-scrollbar {
        display: none;
    }
    .search-icn {
        width: 22px;
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translate(0, 0%);
        cursor: pointer;
    }
    .dispensor {
        width: 1.5px;
        height: 22px;
        background: #A3AAB6;
        margin-right: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/maps/ListSearchBar.vue